import { Link, useParams } from 'react-router';
import { t } from '../../lib/i18n';
import { ErrorPanel } from '../../components/ErrorPanel';
import { Alert, Badge, Card, PageHeader, Spinner } from '../../components/ui';
import { useConsent } from './Consent';

/** /manage/shared-reception/agreement/:version: the data-sharing agreement text, marked as a draft while the server says so. */
export function AgreementPage() {
  const raw = Number(useParams().version);
  const version = Number.isInteger(raw) && raw >= 1 ? raw : 1;
  const q = useConsent(version);
  const a = q.data?.agreement;
  return (
    <>
      <PageHeader
        title={a?.title ?? t('sr.consent.agreementLink')}
        actions={
          <Link className="text-sm font-medium text-brand underline" to="/manage/shared-reception">
            {t('srt.agreement.back')}
          </Link>
        }
      />
      {q.isError ? <ErrorPanel error={q.error} onRetry={() => void q.refetch()} /> : null}
      {!q.data && !q.isError ? <Spinner /> : null}
      {a ? (
        <div className="space-y-4">
          {a.draft ? (
            <Alert kind="info">
              <Badge tone="warn">{t('sr.consent.draftNotice')}</Badge> {t('srt.agreement.draftExplain')}
            </Alert>
          ) : null}
          <Card>
            <div className="space-y-5">
              {a.sections.map((s, i) => (
                <section key={i} aria-labelledby={`dsa-${i}`}>
                  <h2 id={`dsa-${i}`} className="text-base font-semibold text-slate-900">
                    {s.heading}
                  </h2>
                  <p className="mt-1 whitespace-pre-line text-sm text-slate-800">{s.body}</p>
                </section>
              ))}
            </div>
          </Card>
        </div>
      ) : null}
    </>
  );
}
